import { EPaymentProvider } from '../../../types/redux/paymentMethods';

export const PROVIDER_URLS = {
  [EPaymentProvider.YooKassa]: 'https://yookassa.ru/checkout-widget/v1/checkout-widget.js',
  [EPaymentProvider.CloudPayments]: 'https://widget.cloudpayments.ru/bundles/cloudpayments.js',
};

export const TELEMETRY_PREFIXES = {
  [EPaymentProvider.YooKassa]: 'yoo-kassa-widget',
  [EPaymentProvider.CloudPayments]: 'cloud-payments-widget',
};
